import Select, { components } from 'react-select';
import { customStyles } from '../InputSelect';

const DropdownIndicator = ({ children, ...props }) => (
  <components.DropdownIndicator {...props}>
    <svg
      width="10"
      height="5"
      viewBox="0 0 10 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0L5 5L10 0H0Z" fill="#222222" />
    </svg>
  </components.DropdownIndicator>
);

export const SelectCustom = ({
  handleChange,
  selectCustomStyles,
  components,
  ...props
}) => {
  return (
    <Select
      styles={customStyles(selectCustomStyles)}
      onChange={handleChange}
      components={{ DropdownIndicator }}
      isSearchable={false}
      {...props}
    />
  );
};
